import { range } from 'lodash'

import * as S from './styled'

const Shell = ({ quantity = 1 }) => (
  <S.Shell>
    {range(quantity).map((item, index) => (
      <S.Item key={`shell-${index}`} />
    ))}
  </S.Shell>
)

export default Shell
